import React from "react";
import { Route } from "react-router-dom";
import ThreeDSRouter from "../../threeds/ThreeDSRouter";

const ThreeDSRoutes = () => {
  return (
    <Route path="/3ds/*" element={<ThreeDSRouter />} />
  );
};

export default ThreeDSRoutes;